import { render, staticRenderFns } from "./StuExpert.vue?vue&type=template&id=c2ade07c&scoped=true"
import script from "./StuExpert.vue?vue&type=script&lang=js"
export * from "./StuExpert.vue?vue&type=script&lang=js"
import style0 from "./StuExpert.vue?vue&type=style&index=0&id=c2ade07c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ade07c",
  null
  
)

export default component.exports